exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posit .mat-select-content {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n}\n\n.mat-select-panel mat-option.mat-option {\n  height: unset;\n}\n\n.mat-option-text.mat-option-text {\n  white-space: normal;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/oes/select-workspace/workspace-select.component.css
// module id = ../../../../../angular/app/views/oes/select-workspace/workspace-select.component.css
// module chunks = main